import React, { useState } from "react";
import "./SetPassword.css";
import useNotification from "../../hooks/useNotification";
import NotificationSnackbar from "../../components/NotificationSnackbar";
import { Button, TextField, Typography } from "@mui/material";
import api from "../../API/axios";

export default function ConsumerForgotPassword({
  setState,
}: {
  setState?: (state: string) => void;
}) {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { notification, showNotification, hideNotification } =
    useNotification();

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    setLoading(true);

    try{
    const result = await api.post(
      `/ConsumerTwoFactor/forgot-password?email=${encodeURIComponent(email)}`
    );

    if (result) {
      setIsSubmitted(true);
      showNotification("New password sent to your email! Redirecting to login...", "success");
      
      // Auto-redirect to login after 3 seconds
      setTimeout(() => {
        setState && setState("login");
      }, 3000);
    } else {
      showNotification("Failed to send new password. Please try again.", "error");
    }
    setEmail("");
  }catch(error:any){
     if (error?.response?.status === 404 || error?.response?.status === 400) {
      showNotification(
        "User is not registered yet. Please sign up first.",
        "error"
      );
    } 
    
    else {
      showNotification(
        "Failed to send new password. Please try again later.",
        "error"
      );
    }
  }finally{
    setLoading(false);
  }
  };


  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "400px",
        gap: 10,
      }}
    >
      <h3 style={{ marginBottom: 0, color: "#888" }}>Forgotten Password</h3>
      <div
        style={{
          fontSize: "13px",
          width: "100%",
          textAlign: "center",
          color: "#666",
        }}
      >
        <p>
          Enter the email registered against your account.
          <br />
          If a valid email is entered, a new password will be generated and sent to your email.
          <br />
          Please check your email for the new password and use it to log in.
        </p>
      </div>
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          width: "280px",
        }}
      >
        <TextField
          id="forgot-email"
          type="email"
          label={"Email"}
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
          disabled={loading}
          inputProps={{ maxLength: 255 }}
          sx={{
            width: "100%",
            maxWidth: 300,
            marginBottom: 1.5,
          }}
        />
        <Button
          type="submit"
          variant="contained"
          size="large"
          disabled={loading}
          sx={{
            width: "100%",
            backgroundColor: "var(--color-primary)",
            "&:hover": { backgroundColor: "var(--color-secondary)" },
          }}
        >
          {loading ? "Sending..." : "Get New Password"}
        </Button>
        <Typography
          variant="body1"
          onClick={() => setState && setState("login")}
          sx={{
            width: "100%",
            color: "var(--color-primary)",
            textAlign: "center",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Back to login
        </Typography>
      </form>
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
      />
    </div>
  );
}
